/**
 * Centralized allowlists for feature access (voice-test, etc.).
 *
 * CRE Chat / Protocols / modules are gated by `cre/crePermissions.js`
 * (`user.permissions` from Validate). Email allowlists for those modules
 * were removed per Jacky (CRE Web App permissions work).
 */

// ---- Voice-test (dev tooling; not a CRE license permission) ----
const VOICE_TEST_ALLOWED_EMAILS = [
  "faizanaslam.dev@gmail.com",
  "faizanaslam.workspace@gmail.com",
].map((e) => e.toLowerCase());

/**
 * Resolve email for voice-test allowlist (CRE / Radical).
 */
export function resolveVoiceTestUserEmail({
  isCreAuth,
  isRadicalAuth,
  creUser,
  radicalUser,
} = {}) {
  if (isCreAuth) return creUser?.email ?? "";
  if (isRadicalAuth) {
    return radicalUser?.email ?? radicalUser?.userEmail ?? "";
  }
  return "";
}

/**
 * Returns true if the current user may access the voice-test page.
 * In development, allowed for any authenticated session.
 */
export function isVoiceTestAllowedForUser({
  isCreAuth,
  isRadicalAuth,
  creUser,
  radicalUser,
} = {}) {
  if (process.env.NODE_ENV === "development") {
    return Boolean(isCreAuth || isRadicalAuth);
  }

  const email = resolveVoiceTestUserEmail({
    isCreAuth,
    isRadicalAuth,
    creUser,
    radicalUser,
  });
  if (!email || typeof email !== "string") return false;
  return VOICE_TEST_ALLOWED_EMAILS.includes(email.trim().toLowerCase());
}
